export default function RecommendationReportDirective() {
  return {
    template: require('./recommendation-report.html'),
    scope: {
      recommendationId: '=',
      canEdit: '=',
      canDelete: '=',
      recommendationReport: '=',
    },
    controller: 'RecommendationReportController',
    controllerAs: 'recommendationReportVM',
    bindToController: true,
    replace: true
  };
}
